// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2jV0d","label":"Labeled_label__3i2IC","divider":"Labeled_divider__GxjHN"};